import { styled, Typography } from '@material-ui/core'
import {
  WrapperProps,
  DialogButtonsContainerProps,
  DialogVariant,
} from './DialogWithTitleAndButtons.types'

const wrapperWidth: Record<DialogVariant, number> = {
  normal: 540,
  wide: 730,
}

export const Wrapper = styled('div')(
  ({ theme, variant, enableMinWidth }: WrapperProps) => ({
    ...(enableMinWidth
      ? { minWidth: wrapperWidth[variant] }
      : { width: wrapperWidth[variant] }),
    height: 'max-content',
    padding: theme.spacing(),
  })
)

export const DialogContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 3, 0.5, 4),
}))

export const DialogButtonsContainer = styled('div')(
  ({ aligment, theme, direction }: DialogButtonsContainerProps) => ({
    display: 'flex',
    flexDirection: direction || 'row',
    justifyContent: aligment || 'flex-end',
    alignItems: 'center',
    '& .MuiButton-root': {
      padding: theme.spacing(0.7, 2.7),
    },
  })
)

export const DialogTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 700,
  marginBottom: theme.spacing(1.5),
}))

export const DialogDescription = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  marginBottom: theme.spacing(3),
  wordBreak: 'break-word',
}))
